import React, { useState } from "react";
import "./AllFastGamesStyle.scss";
import { allFastGamesTextContent } from "./constant/index";
import GameCard from "../Common_UI_Kit/GameCard";
import { useNavigate } from "react-router-dom";
import GamesFilter from "../GamesFilterSection";
import SearchWidget from "../Common_UI_Kit/SearchWidget";
import CustomButton from "../Common_UI_Kit/CustomButton";

const AllFastGamesSection = () => {
  const { allFastGamesContent, gamesFilterContent } = allFastGamesTextContent;
    
  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/fast-game-play`);
  };

  return (
    <section className="fast-games-section">
      <div className="fast-games-wrap">
        <div className="filters-grid-box">
          <GamesFilter
            filtersText={gamesFilterContent}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
          <SearchWidget />
        </div>
        
        <div className="fast-games-box">
          <div className="games-grid-box">
            {allFastGamesContent.map((game, index) => (
              <GameCard
                key={index}
                gameImageSrc={game.gameImageSrc}
                gameNameText={game.gameNameText}
                gameId={index}
                onClick={() => handleCardClick(index)}
              />
            ))}
          </div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" label={allFastGamesTextContent.btnText} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllFastGamesSection;
